import { render, staticRenderFns } from "./SettingsStates.vue?vue&type=template&id=48efeef0&scoped=true"
import script from "./SettingsStates.vue?vue&type=script&lang=js"
export * from "./SettingsStates.vue?vue&type=script&lang=js"
import style0 from "./SettingsStates.vue?vue&type=style&index=0&id=48efeef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efeef0",
  null
  
)

export default component.exports